import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { MDXProvider } from '@mdx-js/react';
import { Container, makeStyles } from '@material-ui/core';
import { alpha } from '@material-ui/core/styles';
import NavBar from './NavBar';
import TopBar from './TopBar';
import components from './mdx';

const useStyles = makeStyles(theme => ({
  wrapper: {
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    minHeight: '100vh',
    overflow: 'hidden',
    paddingTop: 64,
    position: 'relative',
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 256
    }
  },
  contentContainer: {
    flex: '1 1 auto',
    overflow: 'auto',
    position: 'relative',
    zIndex: 1,
    '&::before': {
      background: `radial-gradient(circle at top left, ${alpha(
        theme.palette.primary.main,
        0.08
      )} 0%, transparent 55%)`,
      content: '""',
      height: 380,
      left: 0,
      pointerEvents: 'none',
      position: 'absolute',
      top: 0,
      width: 380,
      zIndex: -1
    },
    '&::after': {
      background: `radial-gradient(circle at bottom right, ${alpha(
        theme.palette.secondary.main,
        0.08
      )} 0%, transparent 60%)`,
      bottom: 0,
      content: '""',
      height: 420,
      pointerEvents: 'none',
      position: 'absolute',
      right: 0,
      width: 420,
      zIndex: -1
    }
  },
  content: {
    paddingBottom: theme.spacing(10),
    paddingTop: theme.spacing(4)
  },
  contentCard: {
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 24,
    boxShadow:
      theme.palette.type === 'light'
        ? '0 18px 48px rgba(33, 39, 54, 0.08)'
        : '0 18px 48px rgba(0, 0, 0, 0.35)',
    overflow: 'hidden',
    padding: theme.spacing(4, 4, 5),
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      borderRadius: 18,
      marginTop: theme.spacing(2),
      padding: theme.spacing(3, 2.5, 4)
    }
  }
}));

function DocsLayout({ children }) {
  const classes = useStyles();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <>
      <TopBar onMobileNavOpen={() => setMobileNavOpen(true)} />
      <NavBar
        onMobileClose={() => setMobileNavOpen(false)}
        openMobile={isMobileNavOpen}
      />
      <div className={classes.wrapper}>
        <div className={classes.contentContainer}>
          <Container maxWidth="md" className={classes.content}>
            <div className={classes.contentCard}>
              <MDXProvider components={components}>
                {children}
              </MDXProvider>
            </div>
          </Container>
        </div>
      </div>
    </>
  );
}

DocsLayout.propTypes = {
  children: PropTypes.any
};

export default DocsLayout;
